import React from "react";
import { Button } from "views/components/ui/Button";

const CATEGORIES = [
    { name: "All" },
    { name: "AI & ML" },
    { name: "Design" },
    { name: "Development" },
    { name: "Marketing" },
    { name: "Productivity" },
    { name: "Business" },
];

export const CategoryTags = () => {
    return (
        <div className="container py-2 pb-6 px-4 sm:px-6 lg:px-8 border-b border-gray-200">
            <div className="flex flex-wrap gap-2 justify-center">
                {CATEGORIES.map((category) => (
                    <Button
                        key={category.name}
                        variant="outline"
                        size="sm"
                        className="rounded-full"
                    >
                        {category.name}
                    </Button>
                ))}
            </div>
        </div>
    );
};
